export default "__VITE_ASSET__DVWzFrIq__"